import { AmuiLookupResponse } from "@app/models/AmuiLookupResponse";
import { SecurityQuestion } from "@app/models/SecurityQuestion";
import { RegistrationRequest } from "@app/models/RegistrationRequest";
import { AmuiUser } from "@app/models/AmuiUser";
import { Homeowner } from "@app/models/Homeowner";
import { CompleteRegistrationRequest } from '@app/models/CompleteRegistrationRequest';
import { Injectable } from "@angular/core";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class RegistrationApi extends HOAApiBase {
    static $inject: string[] = ['$injector'];

    constructor() {
        super('RegistrationApi')
    }

    public registerUser(registrationRequest: RegistrationRequest): Observable<AmuiUser> {
        this.check({ registrationRequest }, 'is present', v => v != null && typeof v === 'object')

        return this.http.post<AmuiUser>(
            this.createUrl("HOAPass", '/v1/registration/_amuiRegistration'), registrationRequest
        )
    }

    public getSecurityQuestions(): Observable<SecurityQuestion[]> {
        return this.http.get<SecurityQuestion[]>(this.createUrl("HOAPass", '/v1/registration/_securityQuestions'))
    }

    /**
     * Checks to see if the emailAddress is required
     * @param emailAddress
     * @returns {Promise<{success:boolean}>}
     */
    public emailValidation(emailAddress: string): Observable<{ success: boolean }> {
        this.check({ emailAddress }, 'is present', v => v != null && typeof v === 'string')

        return this.http.get<{ success: boolean }>(this.createUrl("HOAPass", '/v1/registration/_emailValidate'), {
            params: {
                'emailAddress': emailAddress
            }
        })
    }

    /**
     * See if the username the user has selected already exists
     */
    public emailAddressExists(emailAddress: string, includeEntitlement: boolean): Observable<AmuiLookupResponse> {
        this.check({ emailAddress }, 'is present', v => v != null && typeof v === 'string')

        return this.http.get<AmuiLookupResponse>(this.createUrl("HOAPass", '/v1/registration/_emailLookup'), {
            params: {
                'emailAddress': emailAddress,
                'includeEntitlement': includeEntitlement,
            }
        })
    }

    public homeownersPost(homeowner: Homeowner): Observable<Homeowner> {
        this.check({ homeowner }, 'is present', v => v != null && typeof v === 'object')

        const { contactInformation, firstName, lastName } = homeowner;
        this.check({ contactInformation, firstName, lastName }, 'is present', v => v != null)

        return this.http.post<Homeowner>(
            this.createUrl('HOAPass', '/v1/registration/_saveHomeowner'),  homeowner)
    }

    public completeRegisterUser(registrationRequest: CompleteRegistrationRequest): Observable<any> {
        return this.http.post(this.createUrl("HOAPass", '/v1/registration'), registrationRequest);
    }
}

